<template>
    <div class="modules">
        <div class="apprentice-simple-card registered-modules-overview">
            <div
                class="row"
                v-if="selected_modules.length">
                <div class="col-12 col-md-8 col-xl-9 margin-bottom">
                    <div class="component-title">
                        <h5 class="title">{{ $t('modules.chosen_modules') }}</h5>
                    </div>
                    <design-2021-module-show-latest-registered-module-component :modules-in="sortedModules">
                    </design-2021-module-show-latest-registered-module-component>
                </div>

                <div class="col-12 col-md-4 col-xl-3">
                    <div class="component-title">
                        <h5 class="title">{{ $t('modules.category_overview') }}</h5>
                    </div>
                    <b-list-group
                        class="tags-group-overview"
                        v-if="tags.length">
                        <b-list-group-item
                            class="tag-item"
                            v-for="tag of tags"
                            :key="tag.id">
                            <span class="tag-name">
                                <i
                                    class="fas fa-fw fa-circle tag-color"
                                    :style="{ color: tag.color }"></i
                                >{{ tag.name }}
                            </span>
                            <span class="tag-hour-count">
                                <i class="far fa-clock time-icon"></i>
                                <div class="time">
                                    <span class="time-duration">{{ tag.duration }}</span>
                                    <span class="time-format">{{ $t('modules.hour') }}</span>
                                </div>
                            </span>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>

            <div
                class="not-found with-header empty-module-list"
                v-else>
                <div
                    class="btn-add-circle icon"
                    v-b-tooltip.hover
                    title="Bekijk alle modules"
                    @click="showModules"></div>
                <div class="alert-notice">{{ $t('modules.no_registered_modules_found') }}</div>
            </div>

            <div v-if="this.$authUser.isStudent()">
                <div
                    class="add-module"
                    v-if="selected_modules.length">
                    <b-button
                        class="btn-add-circle btn-add-module"
                        variant="outline-primary"
                        @click="showModules"
                        >{{ $t('modules.add_module') }}</b-button
                    >
                </div>
            </div>

            <design-2021-module-show-modules-component
                ref="module-show-modules"
                :modules-in="modulesIn"
                :education-levels-in="educationLevelsIn">
            </design-2021-module-show-modules-component>
        </div>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-module-show-component',
    props: {
        modulesIn: Array,
        educationLevelsIn: Array,
    },
    data() {
        return {
            selected_modules: [],
            all_modules: [],
            selected: null,
        };
    },
    mounted() {
        // modules -> module_user -> user
        ords.use('module').add(this.modulesIn);
        ords.hold();
        for (const module of this.modulesIn) {
            for (const moduleUser of module.module_users) {
                ords.use('module_dates').attach(moduleUser.module_date_id, 'module_users', moduleUser.id);
            }
        }
        ords.continue();

        // array met alle modules
        ords.use('module')
            .get()
            .subscribe((all_modules) => {
                this.all_modules = all_modules;
            });

        // we willen een array met de gekozen modules
        ords.use('module')
            .whereHas('module_users')
            .with('module_dates', (dateCallback) => {
                dateCallback.with('module_users');
                dateCallback.with('module_period', (modulePeriodsCallback) => {
                    modulePeriodsCallback.with('period');
                });
            })
            .with('file', (fileCallback) => {
                fileCallback.with('image');
            })
            .with('module_tags')
            .with('module_teachers', (teacherCallbak) => {
                teacherCallbak.with('user');
            })
            .get()
            .subscribe((selected_modules) => {
                this.selected_modules = selected_modules;
            });
    },

    methods: {
        showModules() {
            this.$refs['module-show-modules'].show();
        },
    },

    computed: {
        sortedModules() {
            if (this.selected_modules.length) {
                return this.selected_modules.sort((a, b) => {
                    return new Date(a.updated_at) - new Date(b.updated_at);
                });
            }

            return this.selected_modules.slice(0, 3);
        },

        tags() {
            let tags = [];
            if (this.selected_modules.length) {
                this.selected_modules.forEach((selected) => {
                    selected.module_tags.forEach((module_tag) => {
                        if (tags.length) {
                            if (
                                !tags.some(
                                    (tag) => tag.name.toLocaleLowerCase() === module_tag.name.toLocaleLowerCase(),
                                )
                            ) {
                                tags.push({
                                    id: module_tag.id,
                                    name: module_tag.name,
                                    color: module_tag.color,
                                    duration: 0,
                                });
                            }
                        } else {
                            tags.push({
                                id: module_tag.id,
                                name: module_tag.name,
                                color: module_tag.color,
                                duration: 0,
                            });
                        }
                    });
                });

                if (tags.length > 0) {
                    tags.forEach((tag) => {
                        this.selected_modules.forEach((module) => {
                            let duration = 0;

                            if (module.module_tags.some((module_tag) => module_tag.id === tag.id)) {
                                for (const date of module.module_dates) {
                                    if (date.module_users.length > 0) {
                                        duration += date.module_period.duration;
                                    }
                                }

                                tag.duration += duration;
                            }
                        });
                    });
                }
            }

            return tags;
        },

        barChartData() {
            if (!this.selected_modules.length) {
                return {
                    series: [],
                    options: {},
                };
            }

            const values = this.tags.map((tag) => {
                return {
                    data: [tag.duration],
                    name: tag.name,
                    color: tag.color,
                };
            });

            const tagsLabels = this.tags.map((tag) => tag.name);

            return {
                series: values,
                options: {
                    chart: {
                        toolbar: {
                            show: false,
                        },
                        type: 'bar',
                        height: '350px',
                        fontFamily: 'DM Sans, sans-serif',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                            barHeight: '100%',
                            columnWidth: '45%',
                        },
                    },
                    dataLabels: {
                        enabled: true,
                    },
                    xaxis: {
                        type: 'category',
                        categories: tagsLabels,
                        labels: {
                            show: false,
                        },
                    },
                    yaxis: {
                        min: 0,
                        max: 80,
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                show: false,
                            },
                        },
                        padding: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                        },
                    },
                },
            };
        },
    },

    watch: {
        selected_modules: function (value) {
            this.selected_modules = value;
        },
    },
};
</script>

<style scoped lang="scss">
.tags-group-overview {
    border-radius: 0;

    .list-group-item {
        border: 0;
        padding: map-get($grid-gutter-spacing, 'ten') 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tag-name {
            font-weight: $font-weight-bold;

            .tag-color {
                margin-right: map-get($grid-gutter-spacing, 'eight');
                font-size: 0.625rem;
            }
        }

        .tag-hour-count {
            display: flex;
            align-items: center;
            color: $text-muted-color;
            font-weight: $font-weight-bold;

            i {
                margin-right: map-get($grid-gutter-spacing, 'eight');
                justify-self: flex-start;
            }

            .time {
                width: 55px;
                display: flex;
                justify-content: flex-end;

                .time-duration {
                    margin-right: 3px;
                }
            }
        }

        &:not(:last-child) {
            border-bottom: 3px dotted $border-color;
        }
    }
}

.add-module {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .btn-add-module {
        flex-direction: column;

        &:before {
            margin-right: 0;
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
        }
    }
}

.empty-module-list {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.latest-modules-wrapper ::v-deep {
    .module {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }
}
</style>
